import React from "react";
import SingletonEditor from "./SingletonEditor";

const fields = [
  { key: "story_title", label: "Story Headline" },
  { key: "story_body", label: "Story Body", type: "textarea", rows: 10, help: "Use blank lines to separate paragraphs" },
  { key: "image_url", label: "Image URL", help: "Paste a URL from the Media Library or an external source" },
];

const AboutEditor = () => (
  <SingletonEditor
    resource="about"
    title="About Page"
    eyebrow="Page Content"
    fields={fields}
    testIdPrefix="about-edit"
  />
);
export default AboutEditor;
